export const INIT_REMOTE_DATA = 'INIT_REMOTE_DATA';
export const FETCHING_REMOTE_DATA = 'FETCHING_REMOTE_DATA';
export const SET_REMOTE_DATA = 'SET_REMOTE_DATA';
export const ERROR_IN_REMOTE_DATA = 'ERROR_IN_REMOTE_DATA';
export const CLEAR_REMOTE_DATA = 'CLEAR_REMOTE_DATA';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const PARTIAL_UPDATE_ENTITY = 'PARTIAL_UPDATE_ENTITY';
export const CREATE_ENTITY = 'CREATE_ENTITY';
export const PARTIAL_CREATE_ENTITY = 'PARTIAL_CREATE_ENTITY';
export const INVALIDATE_ENTITY = 'INVALIDATE_ENTITY';
export const CONNECTION_OFFLINE = 'CONNECTION_OFFLINE';
export const CONNECTION_ONLINE = 'CONNECTION_ONLINE';
export const EMPTY_CONTEXT = 'EMPTY_CONTEXT';
export const INVALIDATE_ALL = 'INVALIDATE_ALL';
